import Client from "../../../../../Client";
import { getCurrentMonth, getCurrentMonthPath } from "../../../../../misc/date";
import { MainRouter } from "../../../../../routes";
import { MainWindow } from "../../../MainWindow";

export function SameDay() {
    const { role, role_specific } = Client.account;
    const { month, year } = getCurrentMonth();

    if(role === "admin" || role === "reviewer") {
        MainRouter.goto(`/forms/sameday/all/provinces?m=${month}&y=${year}`);
    } else if(role === "province") {
        MainRouter.goto(`/forms/sameday/all/province?m=${month}&y=${year}&p=${role_specific}`);
    } else if(role === "lgu") {
        MainRouter.goto(`/forms/sameday/all/lgu?m=${month}&y=${year}&l=${role_specific}`);
    }
    
    return <div></div>
}